module.exports = __webpack_public_path__ + "static/media/troll.220b9a3b.png";